import Phaser, {
    Display
} from 'phaser'

let gameScale;
let url;
let videoObj;
let parent;
let vidX;
let vidY;
let playGraphic;
let pauseGraphic;
let progressGraphic;
let progressBar;
let sounds;
let loadingText;

export default class Video extends Phaser.Scene {

    constructor() {
        super('video')
    }

    init(data) {
        url = data.url;
        parent = data.parent;
        vidX = data.x;
        vidY = data.y;
        parent.events.once('shutdown', this.stopped, this);
    }

    preload() {
        gameScale = this.registry.get('scaleIt');

        //We'll assume all videos will be mp4 for now. There are 4 resolutions provided for the videos
        let newUrl = url + '_' + gameScale;
        if (gameScale > 3) {
            newUrl = url + '_4';
        }
        //This scene could be paused BEFORE it's create function is called by the user hitting next/back
        this.events.on('pause', this.paused, this);
        this.events.on('resume', this.resumed, this);

        //If this video hasn't been loaded, load it
        if (!this.cache.video.exists(url + 'Video')) {
            newUrl = '././assets/videos/' + newUrl + '.mp4';
            this.load.video(url + 'Video', newUrl, 'canplay');
            //this.load.video(url + 'Video', newUrl);
            this.load.on('progress', this.checkProgress, this);
        }

        //create the video loading text
        this.createText();

        /*
        if (this.load.isLoading === false) {
            this.ready();
        }
        */
    }

    //create is called when the video has loaded, user may have moved on
    create() {
        sounds = this.scene.get('sounds');

        this.input.setTopOnly(true);
        this.data.set('progress', 0);
        this.data.set('isPlay', true);
        this.startIt();
    }

    stopped() {
        //When the overlay scene is stopped kill video scene
        //The video is still loaded in cache
        this.scene.remove('video');
    }

    //Loaded yet?
    checkProgress(value) {
        if (value == 1) {
            loadingText.visible = false;
            this.load.off('progress');
        }
    }

    //Create the loading text
    createText() {
        /* loadingText = this.make.text({
            text: 'Loading Video...',
            align: 'center',
            x: vidX,
            y: vidY,
            scale: gameScale,
            style: {
                font: 16 + 'px courier',
                fill: '#ffffff'
            }
        });
        loadingText.setOrigin(0);
        */
        loadingText = this.add.dom(vidX, vidY).createFromHTML("Loading Video...");
        loadingText.setScale(gameScale);
        loadingText.setOrigin(0);
        loadingText.setClassName('video');
    }

    paused() {
        //This scene can be paused before the video loads
        if (!this.cache.video.exists(url + 'Video')) {
            loadingText.visible = false;
            //No need to carry on pausing the video that's not even loaded
            return;
        }

        sounds.playBackgroundSound();
        videoObj.stop();
        //record progress to start at same spot
        this.data.set('progress', videoObj.getProgress());

        //hide the graphics
        videoObj.visible = false;
        playGraphic.visible = false;
        pauseGraphic.visible = false;
        progressGraphic.visible = false;


    }

    resumed() {
        if (!this.cache.video.exists(url + 'Video')) {
            loadingText.visible = true;
            //no need to play a video that is not loaded
            return;
        }
        parent.updateTextPosition({
            imgWidth: videoObj.width,
            imgHeight: videoObj.height
        })

        //If the video has loaded
        loadingText.visible = false;
        //record progress to start at same spot
        videoObj.seekTo(this.data.get('progress'));


        //play the background sound again
        sounds.stopBackgroundSound();
        videoObj.play();


        //show the graphics
        try {
            videoObj.visible = true;
            progressGraphic.visible = true;

        } catch {}

    }


    //recalled when location is first loaded
    startIt() {

        //create the video from loaded cache
        videoObj = parent.add.video(vidX, vidY, url + 'Video');


        //check if the user has moved on before hte video loaded
        //Play it if the user is still on screen
        this.resumed();

        videoObj.setOrigin(0);
        videoObj.visible = true;
        videoObj.setInteractive({
            useHandCursor: true
        });

        videoObj.on('pointerover', this.pointerOver, this);
        videoObj.on('pointerout', this.pointerOut, this);
        videoObj.on('pointerup', this.pointerUp, this);
        this.createGraphics();

    }

    //scrub bar for video
    trackIt() {
        let width = progressGraphic.width;
        let pointX = this.input.activePointer.x -
            progressGraphic.x;
        let percentage = pointX / width;
        if (percentage > 1) percentage = 1;
        videoObj.seekTo(percentage);
    }


    //create the icons to play/pause/scrub video
    createGraphics() {
        let size = 50 * gameScale;
        //create play arrow
        playGraphic = parent.add.triangle(0, 0, 0, 0, size, size / 2, 0, size, 0xA0A0A0, 0.5);
        playGraphic.setStrokeStyle(2 * gameScale, 0xffffff, 0.8);

        playGraphic.setOrigin(0.5);
        playGraphic.x = videoObj.x + videoObj.width / 2;
        playGraphic.y = videoObj.y + videoObj.height / 2;

        //create pause symbol
        pauseGraphic = parent.add.container(0, 0);
        let rect1 = parent.add.rectangle(0, 0, size / 4, size, 0xA0A0A0, 0.5)
        rect1.setStrokeStyle(2 * gameScale, 0xffffff, 0.8);
        let rect2 = parent.add.rectangle(size / 2, 0, size / 4, size, 0xA0A0A0, 0.5);
        rect2.setStrokeStyle(2 * gameScale, 0xffffff, 0.8);
        pauseGraphic.add([rect1, rect2]);

        pauseGraphic.x = videoObj.x + videoObj.width / 2 - pauseGraphic.getBounds().width / 2;
        pauseGraphic.y = videoObj.y + videoObj.height / 2;

        //create progress bar
        let bar1 = parent.add.rectangle(0, 0, videoObj.width, 30 * gameScale, 0xffffff, 0.7);
        progressGraphic = parent.add.container(videoObj.x, videoObj.y + videoObj.height); // - bar1.height);
        bar1.setOrigin(0);
        progressBar = parent.add.rectangle(0, 5 * gameScale, videoObj.width, 20 * gameScale, 0xffffff, 0.9);
        progressBar.setOrigin(0);

        progressGraphic.add(bar1);
        progressGraphic.add(progressBar);

        bar1.setInteractive({
            useHandCursor: true
        });

        progressGraphic.setSize(bar1.width, bar1.height);
        //progressGraphic.input.hitArea.setTo(0, 0, bar1.width, bar1.height);
        bar1.on('pointerdown', this.dragBar, this);
        bar1.on('pointerup', this.dropBar, this);
        bar1.on('pointerupoutside', this.dropBar, this);
        bar1.on('pointerdownoutside', this.dropBar, this);
        bar1.on('pointerover', this.pointerOver, this);
        bar1.on('pointerout', this.pointerOut, this);


        playGraphic.setDepth(100);
        pauseGraphic.depth = 101;
        progressGraphic.deph = 102;

        if (this.scene.isPaused('video')) this.paused();

        //hide graphics to start
        this.pointerOut();
    }
    dragBar() {
        this.input.on('pointermove', this.trackIt, this);

    }
    dropBar() {
        this.input.removeListener('pointermove', this.trackIt);

        if (this.input.activePointer.getDistanceX() < 3) {
            this.trackIt();
        }

    }

    pointerUp() {

        if (videoObj.isPlaying()) {
            videoObj.stop();
            playGraphic.visible = true;
            pauseGraphic.visible = false;
        } else {
            videoObj.play();
            playGraphic.visible = false;
            pauseGraphic.visible = true;
        }

        this.data.set('isPlay', videoObj.isPlaying());
    }

    update() {
        progressBar.scaleX = videoObj.getProgress();
        //listen for global mute as video does not auto unmute
        if (videoObj) {
            videoObj.setMute(this.sound.mute);
        }
    }

    pointerOver() {
        // progressGraphic.visible = true;

        if (videoObj.isPlaying()) {
            pauseGraphic.visible = true;
        } else {
            playGraphic.visible = true;
        }

    }
    pointerOut() {
        //HIDE THE PLAY/PAUSE BUTTON
        playGraphic.visible = false;
        pauseGraphic.visible = false;
        // progressGraphic.visible = false;

    }



}